/* globals $, productObj, console, selectionState, allEngravingProducts, qtyCtrlHelpers, ShopifyAPI, alert */
$(document).ready(function(){

  $( 'body' ).on('click','#AddToCart',function(e) {
     e.preventDefault();
      $('.product_error').remove();
    // alert();
    var random_number = Math.floor(new Date().valueOf() * Math.random());      
      var $_this = $(this);
      var items = {};
      var items1 = {};
      var arr=[];
      items1.id = $_this.closest('#AddToCartForm').find('[name="id"]').val();          
      items1.quantity = 1; 
    var prop1 = {};
     prop1['Custom_Bundle'] = random_number;
    if($('#corporate_line1').val() != ''){
       prop1['Line1'] = $('#corporate_line1').val();
    }
    if($('#corporate_line2').val() != ''){
       prop1['Line2'] = $('#corporate_line2').val();
    }
    if($('#corporate_line3').val() != ''){
       prop1['Line3'] = $('#corporate_line3').val();
    }
      items1.properties = prop1;
      arr.push(items1); 

    var engrave_product = $('.product-engrave[selected="true"]').attr('data-product-engrav');
   
      if(engrave_product != ''){
        items.id = engrave_product;
        items.quantity = 1; 
        var prop = {};
        var pro_val = false;
        $('.product-single__engraving input').each(function(){
          if($(this).closest('.line-item-property__field').css('display') != 'none'){
            var cur_val = $(this).val();
            var cur_prop = $(this).attr('data-prop');
             // if(cur_val == ''){
             //  pro_val = false;
             // }
            if(cur_val != '' && cur_prop != ''){
                prop[cur_prop] = cur_val;
              pro_val = true;
            }
          }
        });
        prop['Custom_Bundle'] = random_number;
        prop['Engrave_product'] = true;
        items.properties = prop;
         console.log('prop',prop)
        if(pro_val == true){
        arr.push(items);
        }
        console.log('arr',arr);
        // if(pro_val == false){
        //   $('.product-single__engraving').append('<p class="product_error">Fill all engrave fields.</p>').find('.product_error').fadeIn().delay(2000).fadeOut();
        //   return false;
        // }
      }
      $_this.find('#AddToCartText').text('Thank you!');
        $.ajax({
          type : 'POST',
          url : '/cart/add.js',
          dataType : 'json',
          data : {items:arr},
          success : function(data){
              ajaxCart.load();
              setTimeout(function(){
               $_this.find('#AddToCartText').text('Add to Cart');
              },1000);
          },
          error : function(){
            console.log('error');
          }
        }); 
  });

  $('body').on('click','.ajaxcart__qty--remove', function(e){
    e.preventDefault();
    if($(this).closest('.ajaxcart__product').find('.ajaxcart__product-property.Custom_Bundle').length > 0 ){
      var arr_remove= {};
      var arr=[];
      var new_val = parseInt($(this).closest('.ajaxcart__product').find('.ajaxcart__product-property.Custom_Bundle').attr('data-prop-val'));
      $('.ajaxcart__product').each(function(i, obj) {  
        var line_id = parseInt($(this).find('.ajaxcart__product-property.Custom_Bundle').attr('data-prop-val')); 
          
        if(line_id == new_val && line_id != '' && line_id != undefined ){ 
          arr.push(0);
        }else{
          var qty = $(this).find('.ajaxcart__qty-num').val();
          arr.push(qty);
        }
      });
      console.log('arr',arr);
      jQuery.post('/cart/update.js', { 
        updates: arr,
        async: false,
        error: function(jqXHR, textStatus, errorThrown) {
          console.log('error when removing product from the cart');
        },
        success: function(item) {
         setTimeout(function(){
           ajaxCart.load();
          },500);
        }
      });
    }else{
      console.log(' $(this).attr',  $(this).attr('data-id'));
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            'id': $(this).attr('data-id'),
            'quantity': 0
          },
          dataType: 'json',
          success: function (data){
            //alert("Both Products Remove");
            setTimeout(function(){
           ajaxCart.load();
          },500);
          }
        });
      
    }
  });

  'use strict';

  if ( typeof productObj === 'undefined' ) {
    
    return;
  }

  // Cache vars
  var w = window,
    d = document;

  var engravingMap = window.engravingMap;


  /**
   * Figure out whether selected product has both single winner and perpetual engravings
   */

  var productHasBothEngravingTypes = false;
  var productOnlyHasSingleWinnerEngravingType = false;
  var productOnlyHasPerpetualEngravingType = false;
  (function() {
    var productVariants = productObj.variants;

    for ( var i = 0, l = productVariants.length, variantSKU; i < l; i++ ) {
      variantSKU = productVariants[ i ].sku;
      if (
        engravingMap.hasOwnProperty( variantSKU ) &&
        engravingMap[ variantSKU ]['Single Winner Engraving SKU'] !== '' &&
        engravingMap[ variantSKU ]['Perpetual Engraving SKU'] !== ''
      ) {
        productHasBothEngravingTypes = true;
        break;
      }
    }
  })();

  ( function() {
    if ( ! productHasBothEngravingTypes ) {
      var productVariants = productObj.variants;
      for ( var i = 0, l = productVariants.length, variantSKU; i < l; i++ ) {
        variantSKU = productVariants[ i ].sku;
        if ( ! engravingMap.hasOwnProperty( variantSKU ) ) {
          continue;
        }
        if (
          engravingMap[ variantSKU ]['Single Winner Engraving SKU'] !== ''
        ) {
          productOnlyHasSingleWinnerEngravingType = true;
          break;
        }
        if (
          engravingMap[ variantSKU ]['Perpetual Engraving SKU'] !== ''
        ) {
          productOnlyHasPerpetualEngravingType = true;
          break;
        }
      }

    }
  } )();

  /**
   * State
   */

  var firstEngravingDetailsInputContainer = d.querySelector( '#property-fields__row-1' );
  var alternateFirstEngravingDetailsInputContainer = null;
  if ( ! firstEngravingDetailsInputContainer && document.querySelector( '.product-single__engraving' ) ) {
    alternateFirstEngravingDetailsInputContainer = document.querySelector( '.product-single__engraving' );
  }

  window.selectionState = {

    /************************
     * Dynamic / State Data
     ************************/

    selectedVariant: null,
    selectedEngravingVariant: null,

    activeInputKeys: [], // Filled via input dom search on init

    currentSelections: { // Filled via input dom search on init
      quantity: 1,
      leagueName: '',
      engravingDetails: []
    },

    numericOptionNameToProper: {},
    properOptionNameToNumeric: {},
    shortOptionNameToNumeric: {},
    numericOptionNameToShort: {},

    /************************
     * Static Data
     ************************/

    allVariants: w.productObj.variants,

    inputToCheckToSelector: {
      size: '.swatch.total-size',
            topper: '.swatch.topper',
      color: '.swatch.column-color',
      plaqueQuote: '.swatch.plaque-quote',
      engraving: '.swatch.engraving',
      leagueType: '.swatch.league-type',
      style: '.swatch.style'
    },

    engravingProductNameToTitleMap: {
      'perpetual': 'Perpetual Engraving',
      'single-winner': 'Single Winner Engraving'
    },

    properOptionNameToShort: {
      'Total Size': 'size',
            'Topper': 'topper',
      'Column Color': 'color',
      'Plaque Quote': 'plaqueQuote',
      'League Type': 'leagueType',
      'No Engravings': 'engravings',
      'Year': 'year',
      'Owner Name': 'ownerName',
      'Winner Name': 'winnerName',
      'Team Name': 'teamName',
      'Style': 'style'
    },
    shortOptionNameToProper: {
      size: 'Total Size',
            topper: 'Topper',
      color: 'Column Color',
      plaqueQuote: 'Plaque Quote',
      leagueType: 'League Type',
      engravings: 'No Engravings',
      year: 'Year',
      ownerName: 'Owner Name',
      winnerName: 'Winner Name',
      teamName: 'Team Name',
      style: 'Style',

      'LINE 1 - CUSTOM TEXT (NO EMOJIS)': 'Line 1',
      'LINE 2 - CUSTOM TEXT (NO EMOJIS)': 'Line 2',
      'LINE 3 - CUSTOM TEXT (NO EMOJIS)': 'Line 3',
      'LINE 4 - CUSTOM TEXT (NO EMOJIS)': 'Line 4',
    },

    /************************
     * DomEles
     ************************/

    inputs: {
      // filled dynamically
      size: {},
            topper: {},
      color: {},
      plaqueQuote: {},
      leagueType: {},
      engraving: {},
      style: {},

      // static
      quantity: d.querySelector( '#Quantity' ),
      leagueName: d.querySelector( '#nameue-name' ),
      engravingDetails: {
        // first row added in setFirstEngravingDetailsRow
      },
    },

    controls: {
      engravingTypeButtons: {
        perpetual: {
          selected: true,
          hidden: false,
          domEle: d.getElementById( 'perpetual-button' ),
        },
        singleWinner: {
          selected: false,
          hidden: true,
          domEle: d.getElementById( 'single-winner-button' ),
        }
      },

      addEngravingRow: d.querySelector( '#btnAdd' ),
      removeEngravingRow: d.querySelector( '#btnDel' ),

      addToCartButton: d.querySelector( '#AddToCartText' ),

      increaseQuantityButton: d.querySelector( '#AddToCartForm > div.js-qty > button.js-qty__adjust.js-qty__adjust--plus.icon-fallback-text' ),
      decreaseQuantityButton: d.querySelector( '#AddToCartForm > div.js-qty > button.js-qty__adjust.js-qty__adjust--minus.icon-fallback-text' ),
    },

    extraEngravingTypeDomEles: {
      addEngravingRow: d.querySelector( '#btnAdd' ),
      removeEngravingRow: d.querySelector( '#btnDel' ),

      engravingTopDescription: d.querySelector( '#AddToCartForm > .product-single__engraving > h4' ),
      engravingBottomDescription: d.querySelector( '#AddToCartForm > p' ),

      singleWinnerPreviewImage: d.getElementById( 'single-winner-engraving-preview' ),

      leagueNameFullPropertyField: d.querySelector( '.line-item-property__field' ),
    },

    /******************************************************
     * Click Handlers - Used as onclick so no this usage
     ******************************************************/

    clickHandlers: {

      // Engraving details rows

      addEngravingDetailsRow: function() {
        var allContainers = d.querySelectorAll( 'div[id^="property-fields__row-"]' );
        var newContainer = allContainers[allContainers.length - 1];
        var newIndex = newContainer.id.replace( 'property-fields__row-', '' );

        selectionState.inputs.engravingDetails[newIndex] = {
          container: newContainer,

          year: newContainer.querySelectorAll( 'input[id^="year_"]' )[0],
          teamName: newContainer.querySelectorAll( 'input[id^="team-name_"]' )[0],
          winnerName: newContainer.querySelectorAll( 'input[id^="winner-name_"]' )[0]
        };

        selectionState.setInputtedEngravingDetails();
      },
      removeEngravingDetailsRow: function() {
        // todo: absolutely the worst way to do this
        var indexToRemove = null, strI;
        for (var i = 1; i < 30; i++) {
          strI = i + '';
          if (false === selectionState.inputs.engravingDetails.hasOwnProperty(strI)) {
            indexToRemove = '' + (i - 1);
            break;
          }
        }

        delete selectionState.inputs.engravingDetails[indexToRemove];

        selectionState.setInputtedEngravingDetails();
      },

      // Single winner / perpetual buttons

      perpetualButton: function() {
        if (selectionState.currentSelections.engravingType === 'perpetual' ) {return;}

        // flip the button colors
        //selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = 'white';
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = '#f5f5f5';//BS updated
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.color = 'black';

        //selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = 'black';
        selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = '#244159';//BS updated
        selectionState.controls.engravingTypeButtons.perpetual.domEle.style.color = 'white';

        // show the + / - engraving row buttons
        var extraEngravingDomEles = selectionState.extraEngravingTypeDomEles;
        extraEngravingDomEles.addEngravingRow.style.display = 'inline-block';
        extraEngravingDomEles.removeEngravingRow.style.display = 'inline-block';

        // show the league name input field and input title
        extraEngravingDomEles.leagueNameFullPropertyField.style.display = 'block';

        // update text
        // extraEngravingDomEles.engravingTopDescription.textContent = "Past Year's Winners (up to 19)"; //BS removed
        extraEngravingDomEles.engravingBottomDescription = 'Engravings Ship Separate. Free Engraving includes current and past winners.';

        // hide single winner preview image
        extraEngravingDomEles.singleWinnerPreviewImage.style.display = 'none';

        // flip selected attributes on both buttons
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.setAttribute( 'selected', 'false' );
        selectionState.controls.engravingTypeButtons.perpetual.domEle.setAttribute( 'selected', 'true' );

        // show engraving details rows after the first
        for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
          if (engravingDetailsRowKey !== '1' ) {
            for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
              if (engravingDetailsRowInputKey === 'container' ) {continue;}
              selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsRowInputKey].parentElement.style.display = 'block';
            }
          }
        }

        // todo: this is sloppy
        // update text labels for first engraving details row to
        //   Line 1 (Year Suggested)    Line 2 (Team Name or Text)    Line 3 (Winner name or Additional Text)
        if (selectionState.inputs.engravingDetails.hasOwnProperty( '1' )) {
          var i = 1, inputLabelToSwitchTo = null;
          for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails['1']) {
            if (engravingDetailsRowInputKey === 'container' ) {continue;}

            inputLabelToSwitchTo = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].id.toUpperCase().replace( '-', ' ' );

            i += 1;
            if (inputLabelToSwitchTo) {
              var inputEle = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].parentElement.querySelector( 'label' );
              if (inputEle) {
                inputEle.textContent = inputLabelToSwitchTo;
              }
            }
          }
        }

        // set state
        selectionState.setSelectedEngravingType();
        selectionState.setSelectedEngravingProduct();
      },

      singleWinnerButton: function() {
        if (selectionState.currentSelections.engravingType === 'single winner' ) {return;}

        // flip the button colors
        //selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = 'white';
        selectionState.controls.engravingTypeButtons.perpetual.domEle.style.background = '#f5f5f5';
        selectionState.controls.engravingTypeButtons.perpetual.domEle.style.color = 'black';

        //selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = 'black';
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.background = '#244159';
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.color = 'white';

        // hide the + / - engraving row buttons
        var extraEngravingDomEles = selectionState.extraEngravingTypeDomEles;
        extraEngravingDomEles.addEngravingRow.style.display = 'none';
        extraEngravingDomEles.removeEngravingRow.style.display = 'none';

        // hide the league name input field and input title
        extraEngravingDomEles.leagueNameFullPropertyField.style.display = 'none';

        // update text
        // extraEngravingDomEles.engravingTopDescription.textContent = ""; //BS removed
        extraEngravingDomEles.engravingBottomDescription = 'Engravings Ship Separate.';

        // show single winner preview image
        extraEngravingDomEles.singleWinnerPreviewImage.style.display = 'block';

        // flip selected attributes on both buttons
        selectionState.controls.engravingTypeButtons.singleWinner.domEle.setAttribute( 'selected', 'true' );
        selectionState.controls.engravingTypeButtons.perpetual.domEle.setAttribute( 'selected', 'false' );

        // hide engraving details rows after the first
        for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
          if (engravingDetailsRowKey !== '1' ) {
            for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
              if (engravingDetailsRowInputKey === 'container' ) {continue;}
              selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsRowInputKey].parentElement.style.display = 'none';
            }
          }
        }

        // todo: this is sloppy
        // update text labels for first engraving details row to
        //   Line 1 (Year Suggested)    Line 2 (Team Name or Text)    Line 3 (Winner name or Additional Text)
        if (selectionState.inputs.engravingDetails.hasOwnProperty( '1' )) {
          var i = 1, inputLabelToSwitchTo = null;
          for (var engravingDetailsRowInputKey in selectionState.inputs.engravingDetails['1']) {
            if (engravingDetailsRowInputKey === 'container' ) {continue;}
            if (i === 1) {
              inputLabelToSwitchTo = 'Line 1 (Year Suggested)';
            } else if (i === 2) {
              inputLabelToSwitchTo = 'Line 2 (Team Name or Text)';
            } else if (i === 3) {
              inputLabelToSwitchTo = 'Line 3 (Winner name or Additional Text)';
            } else {
              break;
            }
            i += 1;
            if (inputLabelToSwitchTo) {
              var inputEle = selectionState.inputs.engravingDetails['1'][engravingDetailsRowInputKey].parentElement.querySelector( 'label' );
              if (inputEle) {
                inputEle.textContent = inputLabelToSwitchTo;
              }
            }
          }
        }

        // set state
        selectionState.setSelectedEngravingType();
        selectionState.setSelectedEngravingProduct();
      },

    },

    /************************
     * Gets
     ************************/

    getSelected: function(property) {
      return this.currentSelections[property];
    },

    getSelectedVariant: function() {
      return selectionState.selectedVariant;
    },

    // check the first variant sku, there's no direct productObj.sku
    getEngravingVariantFromEngravingSKU: function(engravingSKU) {
      var matchedEngravingVariant = null,
        engravingProduct,
        engravingVariants,
        engravingVariant;

      for (var c = 0, numProducts = allEngravingProducts.length; c < numProducts; c++) {
        engravingProduct = allEngravingProducts[c];
        engravingVariants = engravingProduct.variants;

        for (var d = 0, numEngravingVariants = engravingVariants.length; d < numEngravingVariants; d++) {
          engravingVariant = engravingVariants[d];
          if (engravingVariant.sku === engravingSKU) {
            matchedEngravingVariant = engravingVariant;
            break;
          }
        }
      }
      return matchedEngravingVariant;
    },

    /************************
     * Setters - Some used as onclick so no this usage
     ************************/

    setSelected: function(property) {
      var propertyInputs = selectionState.inputs[property];
      for (var propertyInput in propertyInputs) {
        if (propertyInputs[propertyInput] && propertyInputs[propertyInput].checked === true) {
          selectionState.currentSelections[property] = propertyInputs[propertyInput].value;
          
          break;
        }
      }
    },

    incrementQuantity: function(dir) { // 'up' || 'down'
      if (dir === 'up' ) {
        selectionState.currentSelections.quantity += 1;
      } else if (dir === 'down' ) {
        selectionState.currentSelections.quantity -= 1;
      }
      
    },

    setSelectedEngravingType: function() {

      // Check that they exist: see https://trophysmack-staging.myshopify.com/collections/rings/products/jewel-case
      var engravingTypeInputExists = false;
      for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
        if (selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle) {
          engravingTypeInputExists = true;
        }
      }

      if (false === engravingTypeInputExists) {

        // If no input use the:
        //  productOnlyHasSingleWinnerEngravingType,
        //  productOnlyHasPerpetualEngravingType
        // variables.
        for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
          
          if (engravingTypeButton === 'perpetual' && productOnlyHasPerpetualEngravingType ) {
            selectionState.currentSelections.engravingType = 'perpetual';
            selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
            
            break;
          } else if ( engravingTypeButton === 'singleWinner' && productOnlyHasSingleWinnerEngravingType ) {
            selectionState.currentSelections.engravingType = 'single winner';
            selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
            
            break;
          }
        }

      } else {
        for (let engravingTypeButton in selectionState.controls.engravingTypeButtons) {
          if (selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle.getAttribute( 'selected' ) === 'true' ) {
            selectionState.currentSelections.engravingType = selectionState.controls.engravingTypeButtons[engravingTypeButton].domEle.innerText.toLowerCase().trim();
            selectionState.controls.engravingTypeButtons[engravingTypeButton].selected = true;
            
            break;
          }
        }
      }

    },
    setInputtedLeagueName: function() {
      if (selectionState.inputs.leagueName) {
        selectionState.currentSelections.leagueName = selectionState.inputs.leagueName.value;
        
      }
    },
    setInputtedEngravingDetails: function() {
      selectionState.currentSelections.engravingDetails = []; // reset

      var detailsToCheck = [
        'year',
        'teamName',
        'winnerName',
        'ownerName',
        'leagueType',

        'LINE 1 - CUSTOM TEXT (NO EMOJIS)',
        'LINE 2 - CUSTOM TEXT (NO EMOJIS)',
        'LINE 3 - CUSTOM TEXT (NO EMOJIS)',
        'LINE 4 - CUSTOM TEXT (NO EMOJIS)',
      ];

      var engravingDetailsRow;
      for (var rowKey in selectionState.inputs.engravingDetails) {
        engravingDetailsRow = selectionState.inputs.engravingDetails[rowKey]; // domEle

        var engravingRowDetails = {};

        for (var i = 0, l = detailsToCheck.length; i < l; i++) {
          if (engravingDetailsRow[detailsToCheck[i]] && engravingDetailsRow[detailsToCheck[i]].value !== '' ) {
            engravingRowDetails[detailsToCheck[i]] = engravingDetailsRow[detailsToCheck[i]].value;
          }
        }
        if (Object.keys(engravingRowDetails).length > 0) {
          selectionState.currentSelections.engravingDetails.push( engravingRowDetails );
        }
      }
      
    },
    // Some products don't have some of the properties
    setSelectedProductVariant: function() {
      var allVariants = selectionState.allVariants;

      if ( allVariants.length === 1 ) {
        selectionState.selectedVariant = allVariants[0];
        
      } else {
        var optionKeyToRequiredValue = {};

        var activeInputKey;
        for ( var i = 0, l = this.activeInputKeys.length; i < l; i++ ) {
          activeInputKey = this.activeInputKeys[ i ];

          var selectedValue = this.getSelected( activeInputKey );

          var numericName = this.shortOptionNameToNumeric[ activeInputKey ];
          if ( typeof numericName !== 'undefined' ) {
            optionKeyToRequiredValue[ numericName ] = selectedValue;
          }
        }

        for (var i = 0, l = allVariants.length, variant; i < l; i++) {
          variant = allVariants[i];

          var isMatch = true;

          for (var optionKey in optionKeyToRequiredValue) {
            if (variant[optionKey] !== optionKeyToRequiredValue[optionKey]) {
              isMatch = false;
            }
          }

          if (isMatch) {
            selectionState.selectedVariant = allVariants[i];
            
            break;
          }
        }
      }
    },

    setSelectedEngravingProduct: function() {
      if (typeof this.selectedVariant === 'undefined' ) {
        
        return;
      }
      
      var selectedVariantSKU = this.selectedVariant.sku;
      for (var variantSKU in engravingMap) {
        if (variantSKU === this.selectedVariant.sku) {
          var selectedEngravingType = this.getSelected( 'engravingType' );

          

          if (selectedEngravingType === 'perpetual' ) {
            var engravingSKU = engravingMap[variantSKU]['Perpetual Engraving SKU'];
          } else if (selectedEngravingType === 'single winner' ) {
            var engravingSKU = engravingMap[variantSKU]['Single Winner Engraving SKU'];
          } else {
            
          }

          
          this.selectedEngravingVariant = this.getEngravingVariantFromEngravingSKU(engravingSKU);

          
          break;
        }
      }
    },


    setInputsForKey: function(key, swatchSelector) {
      if (false === this.inputs.hasOwnProperty(key)) {
        return;
      }
      var inputContainer = d.querySelector(swatchSelector);
      if (!inputContainer) {
            return false;
          }
      var inputs = inputContainer.querySelectorAll( 'input' );
      for (var i = 0, l = inputs.length; i < l; i++) {
        this.inputs[key][inputs[i].value] = inputs[i];
      }
      return true;
    },

    initializeInputSelections: function() {
      var inputFound;
      for (var inputToCheck in this.inputToCheckToSelector) {
        inputFound = this.setInputsForKey(inputToCheck, this.inputToCheckToSelector[inputToCheck]);
        if (true === inputFound) {

          // Add to active keys
          this.activeInputKeys.push(inputToCheck);

          this.currentSelections[inputToCheck] = '';

          // Add onclick handlers to inputs
          for (var input in selectionState.inputs[inputToCheck]) {
            if (!selectionState.inputs[inputToCheck][input]) {continue;}
            (function(inputToCheck) {
              selectionState.inputs[inputToCheck][input].onclick = function() {
                selectionState.setSelected(inputToCheck);
                selectionState.setSelectedProductVariant();
                selectionState.setSelectedEngravingProduct();
              };
            })(inputToCheck);
          }

          // Set initial values
          this.setSelected(inputToCheck);
        }
      }

      // Set non-dynamic inputs
      this.setSelectedEngravingType();
      this.setInputtedLeagueName();
      this.setInputtedEngravingDetails();
    },

    /************************
     * Initialization functions
     ************************/

    // Using productObj.options which is an immediately available array of proper names
    fillOptionNameMappings: function() {
      var productOptions = productObj.options;

      // Use basic product options to fill numeric <-> proper name mappings
      this.numericOptionNameToShort.option1 = this.properOptionNameToShort[productOptions[0]];
      this.numericOptionNameToShort.option2 = this.properOptionNameToShort[productOptions[1]];
      this.numericOptionNameToShort.option3 = this.properOptionNameToShort[productOptions[2]];

      this.numericOptionNameToProper.option1 = this.properOptionNameToShort[productOptions[0]];
      this.numericOptionNameToProper.option2 = this.properOptionNameToShort[productOptions[1]];
      this.numericOptionNameToProper.option3 = this.properOptionNameToShort[productOptions[2]];

      this.properOptionNameToNumeric[productOptions[0]] = 'option1';
      this.properOptionNameToNumeric[productOptions[1]] = 'option2';
      this.properOptionNameToNumeric[productOptions[2]] = 'option3';

      this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[0]]] = 'option1';
      this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[1]]] = 'option2';
      this.shortOptionNameToNumeric[this.properOptionNameToShort[productOptions[2]]] = 'option3';

    },

    setFirstEngravingDetailsRow: function() {
      if (firstEngravingDetailsInputContainer) {
        this.inputs.engravingDetails['1'] = {};
        var detailsInputsToCollect = [
          {keyName: 'year', selector: '#year'},
          {keyName: 'teamName', selector: '#team-name'},
          {keyName: 'winnerName', selector: '#winner-name'},
          {keyName: 'ownerName', selector: '#owner-name'}
        ];
        for (let i = 0, l = detailsInputsToCollect.length; i < l; i++) {
          var engravingDetailDomEle = d.querySelector(detailsInputsToCollect[i].selector);
          if (engravingDetailDomEle) {
            this.inputs.engravingDetails['1'][detailsInputsToCollect[i].keyName] = engravingDetailDomEle;
          }
        }
      } else if ( alternateFirstEngravingDetailsInputContainer ) {
        
        this.inputs.engravingDetails['1'] = {};
        let labels = alternateFirstEngravingDetailsInputContainer.querySelectorAll( 'label' );
        let inputs = alternateFirstEngravingDetailsInputContainer.querySelectorAll( 'input' );
        if ( labels.length && inputs.length && labels.length === inputs.length ) {
          
          for ( let i = 0, l = labels.length; i < l; i++ ) {
            this.inputs.engravingDetails[ '1' ][ labels[ i ].innerText ] = inputs[ i ];
          }
        }
        
      }
    },

    /************************
     * Add To Cart Handlers
     ************************/

    clearLeagueNameAndEngravingDetailsInputs: function() {
      // league name
      if (selectionState.inputs.leagueName) {
        selectionState.inputs.leagueName.value = '';
        selectionState.setInputtedLeagueName();
      }

      // engraving details
      var rowsToRemove = -1;
      for (var engravingDetailsRowKey in selectionState.inputs.engravingDetails) {
        rowsToRemove += 1;
        for (var engravingDetailsKey in selectionState.inputs.engravingDetails[engravingDetailsRowKey]) {
          if (selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsKey]) {
            selectionState.inputs.engravingDetails[engravingDetailsRowKey][engravingDetailsKey].value = '';
          }
        }
      }
      if (rowsToRemove > 0) {
        for (var i = 0; i < rowsToRemove; i++) {
          selectionState.controls.removeEngravingRow.click();
        }
      }
      selectionState.setInputtedEngravingDetails();
    }
  };


  // React to productHasBothEngravingTypes

  if (productHasBothEngravingTypes) { // reveal both buttons
    console.log("productHasBothEngravingTypes",productHasBothEngravingTypes);
    d.getElementById( 'engraving-buttons' ).style.display = 'block';
       var element_btn_disable = document.getElementById("AddToCart");
      element_btn_disable.classList.remove("btn-disable");
    // selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.display = 'initial';
    // selectionState.controls.engravingTypeButtons.singleWinner.domEle.style.display = 'initial';
  } else {
    selectionState.currentSelections.engravingType = 'perpetual';
    // selectionState.getSelected( 'engravingType' ) = function() {return 'perpetual';};
  } // leave them hidden


  // Run initialization functions

  selectionState.setFirstEngravingDetailsRow();

  selectionState.initializeInputSelections();
  selectionState.fillOptionNameMappings();

  // Add onclick state changes
  if (selectionState.controls.addEngravingRow) {
    selectionState.controls.addEngravingRow.onclick = selectionState.clickHandlers.addEngravingDetailsRow;
  }
  if (selectionState.controls.removeEngravingRow) {
    selectionState.controls.removeEngravingRow.onclick = selectionState.clickHandlers.removeEngravingDetailsRow;
  }
  if (selectionState.controls.engravingTypeButtons.perpetual.domEle) {
    selectionState.controls.engravingTypeButtons.perpetual.domEle.onclick = selectionState.clickHandlers.perpetualButton;
  }
  if (selectionState.controls.engravingTypeButtons.singleWinner.domEle) {
    selectionState.controls.engravingTypeButtons.singleWinner.domEle.onclick = selectionState.clickHandlers.singleWinnerButton;
  }
  /* Error code (commented by BYI)
  selectionState.controls.increaseQuantityButton.onclick = function() {
    selectionState.incrementQuantity( 'up' );
  };
  selectionState.controls.decreaseQuantityButton.onclick = function() {
    selectionState.incrementQuantity( 'down' );
  };*/


  // Set initial product and engraving variants

  selectionState.setSelectedProductVariant();
  selectionState.setSelectedEngravingProduct();


  /**
   * Some helpers
   */

  window.qtyCtrlHelpers = {

    variantIdHasAssociatedEngravings: function(variantId) {
      return (
        window.productVariantIdToSku &&
        window.engravingMap &&
        window.productVariantIdToSku.hasOwnProperty(variantId) &&
        engravingMap.hasOwnProperty(window.productVariantIdToSku[variantId])
      );
    },

    disableForFlyoutByVariantId: function(variantId, cartContainer, fullContainer) {
      var associatedProductLink = cartContainer.querySelector( 'a[href*="' + variantId + '"]' );
      if (associatedProductLink) {
        fullContainer = associatedProductLink.parentElement.parentElement.parentElement;
        if (fullContainer.classList.contains( 'ajaxcart__row' )) {
          var quantityCtrl = fullContainer.querySelector( '.ajaxcart__qty' );
          if (quantityCtrl) {
            var minusQnt = quantityCtrl.querySelector( '.ajaxcart__qty--minus' );
            var plusQnt = quantityCtrl.querySelector( '.ajaxcart__qty--plus' );
            if (minusQnt) {minusQnt.remove();}
            if (plusQnt) {plusQnt.remove();}
          }
        }
      }
    }

  };

  /**
   * Add to cart handler
   */
 

});

